import React, { useEffect, useState } from "react";
import Popup from "./Popup";
import WeeklyReview from "../popups/WeeklyReview";
import CollectionStatus from "../popups/CollectionStatus";
import PaymentCollection from "../popups/PaymentCollection";
import SchoolVisit from "../popups/SchoolVisit";
import GuestLectures from "../popups/GuestLectures";
import Invoice from "../popups/Invoice";
import AssessmentStatus from "../popups/AssessmentStatus";
import OjtInternship from "../popups/OjtInternship";
import PlacementPlan from "../popups/PlacementPlan";
import { Button, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getIndustrialVisitreportlist,
  getGuestLecturereportlist,
  getWeeklyVcReviewList,
} from "../features/dashboard/dashboardSlice";
import { getCollectionInfo } from "../features/invoice/invoiceSlice";
import { getSchoolVisitStatus } from "../features/schools/schoolSlice";
import { getAssesmentOverviewList } from "../features/assesments/assesmentSlice";
import { getPlacementReportList } from "../features/placements/placementSlice";
import {
  getPaymentOverview,
  getInvoiceData,
  getInvoiceReceiptPayment,
  getInvoiceReceiptInfo,
} from "../features/payments/paymentSlice";
import { getSchoolVisitCount } from "../features/attendance/attendanceSlice"; // ✅ Import API

import AssignTarget from "../popups/AssignTarget";

const VcPerformance = () => {
  const [isFiltersPanelVisible, setIsFiltersPanelVisible] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [industrialVisitsData, setIndustrialVisitsData] = useState([]);
  const [guestLecturesData, setGuestLecturesData] = useState([]);
  const [paymentOverviewData, setPaymentOverviewData] = useState([]);
  const [assessmentOverviewData, setAssessmentOverviewData] = useState([]);

  const dispatch = useDispatch();

  const collectionInfo = useSelector((state) => state.invoice || {});
  const schoolVisitCountState = useSelector(
    (state) => state.attendance.schoolVisits
  );
  console.log(
    schoolVisitCountState,
    "schoolVisitCountStateschoolVisitCountState"
  );

  const industryvisireportState = useSelector(
    (state) => state.dashboard.industrialvisitreportlists
  );
  const guestlectreportState = useSelector(
    (state) => state.dashboard.guestlecturereportlists
  );
  const schoolvisitstatusState = useSelector(
    (state) => state.school.schoolvisitstatus
  );
  const assessmentOverviewState = useSelector(
    (state) => state?.assesmentlist?.assessmentOverviewlists || []
  );
  const placementReportState = useSelector(
    (state) => state.placementList.placementreportList || 0
  );
  const paymenOverviewState = useSelector(
    (state) => state.payment.paymentOverviews
  );
  const weeklyvcReviewState = useSelector(
    (state) => state.dashboard.getWeeklyVcReviewLists
  );
  const invoiceoverviewState = useSelector(
    (state) => state?.payment?.invoicedatas
  );

  useEffect(() => {
    dispatch(getIndustrialVisitreportlist());
    dispatch(getGuestLecturereportlist());
    dispatch(getWeeklyVcReviewList());
    dispatch(getSchoolVisitStatus());
    dispatch(getAssesmentOverviewList());
    dispatch(getPlacementReportList());
    dispatch(getPaymentOverview());
    dispatch(getInvoiceData());
    dispatch(getSchoolVisitCount());
    dispatch(getCollectionInfo()); // Fetch collection info with default filters or none
    //testing
    dispatch(getInvoiceReceiptInfo());
    dispatch(getInvoiceReceiptPayment());
  }, [dispatch]);

  const openPopup = (type) => setPopupType(type);
  const closePopup = () => setPopupType(null);

  const toggleFiltersPanel = () => {
    setIsFiltersPanelVisible(!isFiltersPanelVisible);
  };

  useEffect(() => {
    // Debug collectionInfo to ensure it’s being updated
    console.log("Collection Info:", collectionInfo);

    if (industryvisireportState && industryvisireportState.data) {
      const totalComplete = industryvisireportState.data.done || 0;
      const totalPending = industryvisireportState.data.pending || 0;

      setIndustrialVisitsData([
        { name: "Done", value: totalComplete },
        { name: "Pending", value: totalPending },
      ]);
    }
    if (guestlectreportState && guestlectreportState.data) {
      const totalComplete = guestlectreportState.data.done || 0;
      const totalPending = guestlectreportState.data.pending || 0;

      setGuestLecturesData([
        { name: "Done", value: totalComplete },
        { name: "Pending", value: totalPending },
      ]);
    }
    if (paymenOverviewState?.data) {
      const totalAchieved = paymenOverviewState.data.done || 0;
      const totalPending = paymenOverviewState.data.pending || 0;

      setPaymentOverviewData([
        { name: "Achieved", value: totalAchieved },
        { name: "Pending", value: totalPending },
      ]);
    }
    if (assessmentOverviewState) {
      const totalPassed = assessmentOverviewState.pass || 0;
      const totalFailed = assessmentOverviewState.fail || 0;

      setAssessmentOverviewData([
        { name: "Pass", value: totalPassed },
        { name: "Fail", value: totalFailed },
      ]);
    }
  }, [
    industryvisireportState,
    guestlectreportState,
    paymenOverviewState,
    assessmentOverviewState,
    collectionInfo, // Add collectionInfo to dependencies to re-run when it updates
  ]);

  return (
    <div
      style={{ backgroundColor: "#eaedf2", fontFamily: "Poppins, sans-serif", minHeight: "100vh" }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
        {/* Header Section */}
        <header
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            ...(window.innerWidth <= 768 && {
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "10px",
            }),
          }}
        >
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#2d3748",
              ...(window.innerWidth <= 768 && {
                fontSize: "20px",
              }),
            }}
          >
            VC Performance Dashboard
          </h1>
        </header>

        {/* Filters Panel */}
        {isFiltersPanelVisible && (
          <div
            style={{
              backgroundColor: "#fff",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              padding: "20px",
              marginBottom: "20px",
              ...(window.innerWidth <= 768 && {
                padding: "12px",
                width: "90%", // Match card width on mobile
                maxWidth: "300px", // Match card maxWidth on mobile
                marginLeft: "auto",
                marginRight: "auto",
              }),
            }}
          >
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "12px",
                ...(window.innerWidth <= 768 && {
                  fontSize: "16px",
                  marginBottom: "8px",
                }),
              }}
            >
              Filters
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                gap: "16px",
                ...(window.innerWidth <= 768 && {
                  gridTemplateColumns: "1fr", // Single column on mobile
                  gap: "6px",
                }),
              }}
            >
              <Select placeholder="Select State" style={{ width: 150 }}>
                <option>Rajasthan</option>
                <option>Punjab</option>
              </Select>
              <select
                style={{
                  padding: "8px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "4px",
                  ...(window.innerWidth <= 768 && {
                    width: "100%",
                    padding: "4px",
                    fontSize: "12px",
                  }),
                }}
              >
                <option>Select Cluster</option>
                <option>Cluster 1</option>
                <option>Cluster 2</option>
              </select>
              <select
                style={{
                  padding: "8px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "4px",
                  ...(window.innerWidth <= 768 && {
                    width: "100%",
                    padding: "4px",
                    fontSize: "12px",
                  }),
                }}
              >
                <option>Select VC Name</option>
                <option>Ajay</option>
                <option>Pawan</option>
              </select>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  htmlFor="from-date"
                  style={{
                    color: "#718096",
                    marginBottom: "4px",
                    ...(window.innerWidth <= 768 && {
                      fontSize: "12px",
                    }),
                  }}
                >
                  From
                </label>
                <input
                  type="date"
                  id="from-date"
                  style={{
                    padding: "8px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "4px",
                    ...(window.innerWidth <= 768 && {
                      width: "100%",
                      padding: "4px",
                      fontSize: "12px",
                    }),
                  }}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  htmlFor="to-date"
                  style={{
                    color: "#718096",
                    marginBottom: "4px",
                    ...(window.innerWidth <= 768 && {
                      fontSize: "12px",
                    }),
                  }}
                >
                  To
                </label>
                <input
                  type="date"
                  id="to-date"
                  style={{
                    padding: "8px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "4px",
                    ...(window.innerWidth <= 768 && {
                      width: "100%",
                      padding: "4px",
                      fontSize: "12px",
                    }),
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "16px",
                gap: "16px",
                ...(window.innerWidth <= 768 && {
                  flexDirection: "column",
                  gap: "8px",
                }),
              }}
            >
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#f56565",
                  color: "#fff",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  border: "none",
                  cursor: "pointer",
                  ...(window.innerWidth <= 768 && {
                    width: "100%",
                    padding: "4px 8px",
                    fontSize: "12px",
                  }),
                }}
              >
                Reset Filters
              </Button>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#48bb78",
                  color: "#fff",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  border: "none",
                  cursor: "pointer",
                  ...(window.innerWidth <= 768 && {
                    width: "100%",
                    padding: "4px 8px",
                    fontSize: "12px",
                  }),
                }}
              >
                Apply Filters
              </Button>
            </div>
          </div>
        )}

        {/* Cards Section */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            gap: "16px",
            marginBottom: "20px",
            ...(window.innerWidth <= 768 && {
              gridTemplateColumns: "1fr", // One card per row on mobile
              justifyItems: "center",
              maxWidth: "100%",
            }),
          }}
        >
          {[
            {
              title: "Weekly VC Review Report",
              info1: "Approved",
              info2: "Pending",
              approved: weeklyvcReviewState?.vcWeeklyCount?.approved || 0,
              pending: weeklyvcReviewState?.vcWeeklyCount?.rejected || 0,
              buttonText: "Open Report",
              onClick: () => openPopup("weeklyReview"),
            },
            {
              title: "Collection Status",
              info1: "Completed",
              info2: "Pending",
              approved: collectionInfo.invoicedatas.completedCount || 0,
              pending: collectionInfo.invoicedatas.pendingCount || 0,
              buttonText: "View Collection",
              onClick: () => openPopup("collectionStatus"),
            },
            {
              title: "Payment Collection Targets",
              info1: "Achieved",
              info2: "Pending",
              approved: paymentOverviewData[0]?.value || 0,
              pending: paymentOverviewData[1]?.value || 0,
              buttonText: "State-Wise & VC-Wise",
              onClick: () => openPopup("paymentCollection"),
            },
            {
              title: "Assign Target",
              info1: "Total target",
              approved: schoolVisitCountState?.visits
                ? schoolVisitCountState?.visits.length
                : 0,
              buttonText: "Assign Target",
              onClick: () => openPopup("AssignTarget"),
            },
            {
              title: "School Visit Targets",
              // info1: "Planned",
              // info2: "Remaining",
              // approved:
              //   schoolvisitstatusState.completed +
              //     schoolvisitstatusState.pending || 0,
              // pending: schoolvisitstatusState.pending || 0,
              buttonText: "View Details",
              onClick: () => openPopup("schoolVisit"),
            },
            {
              title: "Guest Lectures & Industrial Visits",
              info1: "Completed",
              info2: "Pending",
              approved:
                (guestLecturesData[0]?.value || 0) +
                (industrialVisitsData[0]?.value || 0),
              pending:
                (guestLecturesData[1]?.value || 0) +
                (industrialVisitsData[1]?.value || 0),
              buttonText: "View Overview",
              onClick: () => openPopup("guestLectures"),
            },
            {
              title: "Invoice Raised vs Submitted",
              info1: "Raised",
              info2: "Pending",
              approved: invoiceoverviewState?.invoiceCount || 0,
              pending: invoiceoverviewState?.pendingCount || 0,
              buttonText: "Open Overview",
              onClick: () => openPopup("invoice"),
            },
            {
              title: "OJT/Internship Process",
              info1: "Organized",
              info2: "Pending",
              approved: 0,
              pending: 0,
              buttonText: "Open Overview",
              onClick: () => openPopup("ojtInternship"),
            },
            {
              title: "Placement Planned vs Actual",
              info1: "Placed",
              info2: "Pending",
              approved: placementReportState?.placed || 0,
              pending: placementReportState?.notPlaced || 0,
              buttonText: "Open Overview",
              onClick: () => openPopup("placementPlannedActual"),
            },
            {
              title: "Assessment Overview",
              info1: "Completed",
              info2: "Pending",
              approved: assessmentOverviewData[0]?.value || 0,
              pending: assessmentOverviewData[1]?.value || 0,
              buttonText: "Open Overview",
              onClick: () => openPopup("assessmentOverview"),
            },
          ].map((card, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#fff",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px",
                padding: "20px",
                width: "100%",
                ...(window.innerWidth <= 768 && {
                  width: "90%", // Match card width on mobile
                  maxWidth: "300px", // Match card maxWidth on mobile
                  padding: "12px",
                  fontSize: "14px",
                }),
              }}
            >
              <h3
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  ...(window.innerWidth <= 768 && {
                    fontSize: "14px",
                  }),
                }}
              >
                {card.title}
              </h3>
              <p
                style={{
                  color: "#48bb78",
                  ...(window.innerWidth <= 768 && {
                    fontSize: "12px",
                  }),
                }}
              >
                {card.info1}: {card.approved}
              </p>
              <p
                style={{
                  color: "#f56565",
                  ...(window.innerWidth <= 768 && {
                    fontSize: "12px",
                  }),
                }}
              >
                {card.info2}: {card.pending}
              </p>
              <Button
                variant="contained"
                onClick={card.onClick}
                style={{
                  marginTop: "12px",
                  backgroundColor: "#4299e1",
                  color: "#fff",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  border: "none",
                  cursor: "pointer",
                  ...(window.innerWidth <= 768 && {
                    width: "100%",
                    padding: "6px 12px",
                    fontSize: "12px",
                  }),
                }}
              >
                {card.buttonText}
              </Button>
            </div>
          ))}
        </div>

        <Popup isOpen={popupType !== null} onClose={closePopup}>
          {popupType === "weeklyReview" && <WeeklyReview />}
          {popupType === "collectionStatus" && <CollectionStatus />}
          {popupType === "paymentCollection" && <PaymentCollection />}
          {popupType === "schoolVisit" && <SchoolVisit />}
          {popupType === "guestLectures" && <GuestLectures />}
          {popupType === "invoice" && <Invoice />}
          {popupType === "ojtInternship" && <OjtInternship />}
          {popupType === "placementPlannedActual" && <PlacementPlan />}
          {popupType === "assessmentOverview" && <AssessmentStatus />}
          {popupType === "AssignTarget" && <AssignTarget />}
        </Popup>

        {/* Leaderboard Section */}
        <div
          style={{
            backgroundColor: "#fff",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            padding: "20px",
            marginBottom: "20px",
            ...(window.innerWidth <= 768 && {
              padding: "12px",
              width: "90%", // Match card width on mobile
              maxWidth: "300px", // Match card maxWidth on mobile
              marginLeft: "auto",
              marginRight: "auto",
              overflowX: "auto",
            }),
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "600",
              marginBottom: "12px",
              ...(window.innerWidth <= 768 && {
                fontSize: "16px",
                marginBottom: "8px",
              }),
            }}
          >
            Leaderboard
          </h2>
          <table style={{ width: "100%", fontSize: "14px" }}>
            <thead style={{ backgroundColor: "#edf2f7" }}>
              <tr>
                <th style={{ padding: "8px" }}>Rank</th>
                <th style={{ padding: "8px" }}>VC Name</th>
                <th style={{ padding: "8px" }}>State/District</th>
                <th style={{ padding: "8px" }}>Tasks Completed</th>
                <th style={{ padding: "8px" }}>On-Time Percentage</th>
                <th style={{ padding: "8px" }}>Performance Score</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  rank: 1,
                  name: "Binita Sahu",
                  state: "WB",
                  tasks: 9,
                  percentage: "100%",
                  score: 95,
                  icon: "🥇",
                  iconColor: "#d69e2e",
                },
                {
                  rank: 2,
                  name: "Raghav",
                  state: "RJ",
                  tasks: 8,
                  percentage: "90%",
                  score: 90,
                  icon: "🥈",
                  iconColor: "#a0aec0",
                },
                {
                  rank: 3,
                  name: "Sarbani Sarkar",
                  state: "WB",
                  tasks: 7,
                  percentage: "80%",
                  score: 85,
                  icon: "🥉",
                  iconColor: "#dd6b20",
                },
                {
                  rank: 4,
                  name: "Madresh",
                  state: "RJ",
                  tasks: 6,
                  percentage: "70%",
                  score: 80,
                },
                {
                  rank: 5,
                  name: "Aditya",
                  state: "RJ",
                  tasks: 5,
                  percentage: "60%",
                  score: 75,
                },
              ].map((entry, index) => (
                <tr key={index}>
                  <td style={{ padding: "8px" }}>
                    {entry.rank}{" "}
                    {entry.icon && (
                      <span style={{ color: entry.iconColor }}>
                        {entry.icon}
                      </span>
                    )}
                  </td>
                  <td style={{ padding: "8px" }}>{entry.name}</td>
                  <td style={{ padding: "8px" }}>{entry.state}</td>
                  <td style={{ padding: "8px" }}>{entry.tasks}</td>
                  <td style={{ padding: "8px" }}>{entry.percentage}</td>
                  <td style={{ padding: "8px" }}>{entry.score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VcPerformance;
